export default __webpack_public_path__ + "static/media/mountain.f2b9906d.webp";